import React, { MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import i18n from '../../i18n';
import { redirectToLogin } from "../../util";

export const DeleteUserButton: React.FC = () => {
    const navigate = useNavigate();

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        let token = window.sessionStorage.getItem('access_token');
        if (token === null) {
            redirectToLogin();
        } else {
            navigate('/delete');
        }
    };

    return (
        <div className="col-12 pt-5 pe-0">
            {/* eslint-disable-next-line */}
            <a href="#" className="button" onClick={handleClick}>{i18n.t('BtnDeleteAccount')}</a>
        </div>
    );
}